export default __webpack_public_path__ + "6a04ea1dadd6d816e55cdbceefd637e6.png";